import React from "react";
import { SVGIcons, ImgIcons, withRouter } from "../../Helpers/Common";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FreeMode, Pagination, Navigation } from "swiper";
import { motion } from "framer-motion";
import { Childlock } from "../Childlock/Childlock";
import { BrowserRouter as Router, Link } from "react-router-dom";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import BarLoader from "react-spinners/BarLoader";
var ImageData = "";
var SVGIcon = "";

ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class DeskSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultSearch: false,
      slug: "",
      userData: false,
      datasearch: false,
      // showShimmer: true,
    };
  }
  desksearch() {
    this.setState({ datasearch: true });
  }
  // handleTimeout = () => {
  //   this.setState({ showShimmer: false });
  // };

  // componentDidMount() {
  //   this.timer = setTimeout(() => {
  //     this.setState({ showShimmer: false });
  //   }, 1000);
  // }

  // componentWillUnmount() {
  //   clearTimeout(this.timer);
  // }
  render() {
    var DefaultSearch;
    var Noresult;

    if (this.props.searchedData === false) {
      // return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    } else {
      if (this.props.searchedData.success == true && this.props.functions.state.searchkeyword !== false) {
        DefaultSearch = this.props.searchedData.searchData.map(
          (MasterDefault) => {
            return (
              <section className="mb-0" key={MasterDefault.ID}>
                <div className="temp14 dD-block">
                  {/* {this.state.showShimmer ? (
                    <div className="line linedesk" />
                  ) : (
                    <>
                        </>
                  )} */}
                  <div className="head temp14-head">
                    <h4>
                      {MasterDefault.displayTitle}
                      <span className="red">
                        {" "}
                        {MasterDefault.displayTitleSuffix}
                      </span>
                    </h4>
                  </div>
                  <div className="temp14-area">
                    <div className="side-overlay-L dD-block"></div>
                    <div className="side-overlay-R dD-block"></div>
                    <Swiper
                      navigation={{
                        prevEl: ".slick-prev",
                        nextEl: ".slick-next",
                      }}
                      slidesPerView={2.4}
                      spaceBetween={16}
                      freeMode={true}
                      loop={false}
                      loopFillGroupWithBlank={true}
                      centeredSlides={false}
                      breakpoints={{
                        650: {
                          slidesPerView: 1,
                        },
                        850: {
                          slidesPerView: 6.3,
                        },
                      }}
                      modules={[FreeMode, Pagination, Navigation]}
                      className="temp14-slider"
                    >
                      <button
                        className="slick-prev slick-arrow"
                        type="button"
                        aria-label="Previous"
                      />
                      {MasterDefault.contents.map((data, indexin) => {
                        var keyword = data.keywords.split(",");
                        keyword = keyword[0];
                        var premium = "";
                        if (data.premium && !data.original_tag) {
                          var premium = (
                            <img
                              src={this.props.silverIcon}
                              style={{
                                width: "1.7rem",
                                "margin-right": "3px",
                                "margin-bottom": "2px",
                              }}
                            />
                          );
                        }
                        if (data.original_tag && data.premium) {
                          var original = (
                            <img
                              src={this.props.goldenIcon}
                              style={{
                                width: "1.7rem",
                                "margin-right": "3px",
                                "margin-bottom": "2px",
                              }}
                            />
                          );
                        }
                        return (
                          <SwiperSlide key={data.ID} className="temp14-item">
                            {/* {this.state.showShimmer ? (
                              <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" />
                            ) : (
                              <>   </>
                              )} */}
                            <div className="temp14-itemColor">
                              <a href={"/" + data.slug}>
                                <img
                                  src={data.vertical_banner.small}
                                  alt="DocuBay"
                                />
                              </a>
                            </div>
                            <div className="bay-title">{keyword}</div>
                            <div className="premium-red">
                              {premium}
                              {original}
                            </div>
                          </SwiperSlide>
                        );
                      })}
                      <SwiperSlide></SwiperSlide>
                      <button
                        className="slick-next slick-arrow"
                        type="button"
                        aria-label="Next"
                      />
                    </Swiper>
                  </div>
                </div>
              </section>
            );
          }
        );
      }

      if (this.props.searchedData.success == false) {
        Noresult = (
          <section className="mb-0">
            <div className="notification-message">
              <p>
                {this.props.searchedData.message} <span></span>
              </p>
            </div>
          </section>
        );
      }

      return (
        <>
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            key="1"
          >
            <main className="mainDeskSearch dD-block">
              {DefaultSearch}
              {Noresult}
              <Mobilemenu active="1" />
            </main>
            {this.state.userData != false ? (
              <Childlock data={this.state.userData} />
            ) : null}
          </motion.div>
        </>
      );
    }
  }
}

export default withRouter(DeskSearch);
